import React from 'react';
import { useCommentsWithButton } from '../../toolympus/components/Comments';
import { useUser } from '../../toolympus/userContext/UserContext';

interface Props {
  entity: string;
  id: string;
}

export const useLocusComments = (entity: string, id: string) => {
  const { user } = useUser();
  const comments = useCommentsWithButton("/api/comment", entity, id, {
    userDict: "Admins",
    isRemoveAllowed: () => !!user?.roles?.includes("manager"),
  })

  return comments;
}

export const CommentsButton = (props: Props) => {
  const comments = useLocusComments(props.entity, props.id);
  return (<>
    {comments.button}
  </>
  );
}
